import {
  ApiPrefixes,
  AuthApiSlugs,
  EmailLoginDto,
  EmailLoginResponseDto,
  LoginDto,
  TokenExpireTimestampDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../api-caller.service';

export class LoginAuthConnector {
  private slug = AuthApiSlugs.LOGIN;

  constructor(
    private apiCaller: ApiCaller,
    private prefix: string,
  ) {}

  checkWhatExistWithEmail(loginDto: EmailLoginDto): Observable<EmailLoginResponseDto> {
    return this.apiCaller.postRequest<EmailLoginResponseDto>(
      ApiPrefixes.AUTH,
      `${this.slug}/email`,
      loginDto,
    );
  }

  loginUserRegistration(loginDto: LoginDto): Observable<TokenExpireTimestampDto> {
    return this.apiCaller.postRequest<TokenExpireTimestampDto>(
      ApiPrefixes.AUTH,
      `${this.slug}/user-registration`,
      loginDto,
    );
  }

  forgotPassword(email: string): Observable<void> {
    return this.apiCaller.postRequest<void>(ApiPrefixes.AUTH, `${this.slug}/forgot-password`, {
      email,
    });
  }
}
